import React, { Component } from 'react';
import classes from './style.module.css'
import { MATCH_TABLE_COLUMNS_ALL, HOME, AWAY, ODDS_BETS_365_XPATH, ODDS_BETS_PINNACLE_XPATH, ODDS_BETS_SBO_XPATH, ODDS_BETS_BWIN_XPATH, ODDS_BETS_WILLIAM_HILL_XPATH, ODDS_BETS_MARATHON_BET_XPATH } from '../../../constants/Constants'
import { Image } from 'react-bootstrap';
import ReactCountryFlag from "react-country-flag";
import jp from 'jsonpath';
import { getMatchScore } from '../../../service/backend-api-service';
const countryData = require('country-data');

class Match extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bgColor: ""
        }
    }

    getCountry(code){
        if(!code){
            return ""
        }
        if(countryData && countryData.countries[code]){
            const countryName= countryData.countries[code].name
           return countryName.split(",")[0];
        }
        return code.replace(',', ' ');
    }
    rowClicked = (e) => {
        this.setState({ bgColor: (this.state.bgColor === '#947978') ? "" : '#947978' });
    }

    render() {
        const props = this.props;
        const rowIndex = props.index + 1;
        const id = props.item.id;

        const columnList = props.finalColumns;

        const bets365Details = props.item.matchOdd ? jp.query(props.item.matchOdd, ODDS_BETS_365_XPATH) : null;
        //const pinnacleDetails = props.item.matchOdd ? jp.query(props.item.matchOdd, ODDS_BETS_PINNACLE_XPATH) : null;
        //const sboDetails = props.item.matchOdd ? jp.query(props.item.matchOdd, ODDS_BETS_SBO_XPATH) : null;
        //const bwinDetails = props.item.matchOdd ? jp.query(props.item.matchOdd, ODDS_BETS_BWIN_XPATH) : null;
        //const williamHillDetails = props.item.matchOdd ? jp.query(props.item.matchOdd, ODDS_BETS_WILLIAM_HILL_XPATH) : null;
        //const marathonBetDetails = props.item.matchOdd ? jp.query(props.item.matchOdd, ODDS_BETS_MARATHON_BET_XPATH) : null;

        function getDetails(jsonPath) {
            const result365 = jp.query(bets365Details, jsonPath);
            if (result365 != null) {
                return result365;
            }
            /* const pinnacelData =  jp.query(pinnacleDetails, jsonPath);
             if(pinnacelData != null){
                 return pinnacelData;
             }
             const sboData =  jp.query(sboDetails, jsonPath);
             if(sboData != null){
                 return sboData;
             }
             const bwinData =  jp.query(bwinDetails, jsonPath);
             if(bwinData != null){
                 return bwinData;
             }
             const williamData =  jp.query(williamHillDetails, jsonPath);
             if(williamData != null){
                 return williamData;
             }
             const marathonData =  jp.query(marathonBetDetails, jsonPath);
             if(marathonData != null){
                 return marathonData;
             }*/
            return null;
        }

        function formatScore(home, away) {

            if (home != null && away != null && home != 'null' && away != 'null') {
                //console.log("result:" + home + "-" + away + dot);
                return home + "-" + away;
            }
            return "-";
        }

        function formatNumber(value) {
            if (Number.isFinite(value)) {
                return Math.round(value * 100) / 100;
            }
            return value;
        }

        function getCountryMap(code) {
            if(code){
                const codeSmall = "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/" + (code ? code.toLowerCase() : "") + ".svg"
                return <Image src={codeSmall} rounded />
            }
            return null
        }

        const cells = columnList.map(column => {
            let cell = null;
            const cellKey = id + "_" + column.id
            const dot = <span style={{ color: 'rgb(233, 232, 229)' }}>.</span>;
            switch (column.id) {
                case MATCH_TABLE_COLUMNS_ALL.ROW_NUM.id:
                    cell = <th key={cellKey} className={classes.MatchTdTh} scope="row">{rowIndex}</th>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.COUNTRY_FLAG.id:
                    const flag = getCountryMap(props.item.countryCodeISO2)
                    cell = <td key={cellKey} className={classes.MatchTdTh}>
                            {flag}
                            </td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.COUNTRY.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>
                        {this.getCountry(props.item.countryCodeISO2)}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.LEAGUE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.league}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.HOME.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.home}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.AWAY.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.away}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.DATE.id:
                    var ddmmyyyy = '';
                    let yyyymmdd = props.item.date;
                    if (yyyymmdd) {
                        ddmmyyyy = yyyymmdd.substring(6, 8) + "-" + yyyymmdd.substring(4, 6) +
                            "-" + yyyymmdd.substring(0, 4);
                    }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{ddmmyyyy}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.TIME.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.time}</td>
                    break;
                // home stats
                case MATCH_TABLE_COLUMNS_ALL.H_GOAL_POINT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ?
                        props.item.homeStat.gpT
                        :
                        props.item.homeStat.gpTT
                        : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_GOAL_POINT_WIN.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ?
                        props.item.homeStat.gpW
                        :
                        props.item.homeStat.gpWT
                        : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_GOAL_POINT_DRAW.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ?
                        props.item.homeStat.gpD
                        :
                        props.item.homeStat.gpDT
                        : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_GOAL_POINT_LOSE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ?
                        props.item.homeStat.gpL
                        :
                        props.item.homeStat.gpLT
                        : "-"}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.H_POINT_PER_GAME.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.pointPerGame : props.item.homeStat.pointPerGameTotal : "-"}</td>
                    break;



                case MATCH_TABLE_COLUMNS_ALL.H_GOALS_SCORED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.goalsScored : props.item.homeStat.goalsScoredTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_GOALS_CONCEDED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.goalsConceded : props.item.homeStat.goalsConcededTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_AVG_GOALS_SCORED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.avgGoalsScored : props.item.homeStat.avgGoalsScoredTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_AVG_GOALS_CONCEDED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.avgGoalsConceded : props.item.homeStat.avgGoalsConcededTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_AVG_GOALS_SCORED_CONCEDED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{formatNumber(props.item.homeStat ? props.home === HOME ? props.item.homeStat.avgGoalsScoredConc : props.item.homeStat.avgGoalsScoredConcTotal : "-")}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_ONE_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overOnePointFiveGoals : props.item.homeStat.overOnePointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_TWO_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overTwoPointFiveGoals : props.item.homeStat.overTwoPointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_THREE_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overThreePointFiveGoals : props.item.homeStat.overThreePointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_FOUR_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overFourPointFiveGoals : props.item.homeStat.overFourPointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_FIVE_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overFivePointFiveGoals : props.item.homeStat.overFivePointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_ZERO_POINT_FIVE_HT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overZeroPointFiveGoalsHT : props.item.homeStat.overZeroPointFiveGoalsHTTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_ONE_POINT_FIVE_HT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overOnePointFiveGoalsHT : props.item.homeStat.overOnePointFiveGoalsHTTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_OVER_TWO_POINT_FIVE_HT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.overTwoPointFiveGoalsHT : props.item.homeStat.overTwoPointFiveGoalsHTTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_CLEAN_SHEETS.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.cleanSheets : props.item.homeStat.cleanSheetsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_WON_TO_NIL.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.wonToNil : props.item.homeStat.wonToNilTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_SCORED_IN_BOTH_HALVES.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.scoredInBothHalves : props.item.homeStat.scoredInBothHalvesTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_BOTH_TEAMS_SCORED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.bothTeamsScored : props.item.homeStat.bothTeamsScoredTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_FAILED_TO_SCORE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.failedToScore : props.item.homeStat.failedToScoreTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_LOST_TO_NIL.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.lostToNil : props.item.homeStat.lostToNilTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.H_CONCEDED_IN_BOTH_HALVES.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.concededInBothHalves : props.item.homeStat.concededInBothHalvesTotal : "-"}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.cpm : props.item.homeStat.cpmT : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_AGAINST_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.capm : props.item.homeStat.capmT : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_TTL_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.tcpm : props.item.homeStat.tcpmT : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_OVER_9_5_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.o9_5 : props.item.homeStat.o9_5T : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_OVER_10_5_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.o10_5 : props.item.homeStat.o10_5T : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_OVER_11_5_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.o11_5 : props.item.homeStat.o11_5T : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_OVER_12_5_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.o12_5 : props.item.homeStat.o12_5T : "-"}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.H_CORNER_OVER_13_5_PER_MATCH.id:
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.homeStat ? props.home === HOME ? props.item.homeStat.o13_5 : props.item.homeStat.o13_5T : "-"}</td>
                break;

                // away stats
                case MATCH_TABLE_COLUMNS_ALL.A_GOAL_POINT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ?
                        props.item.awayStat.gpT
                        :
                        props.item.awayStat.gpTT
                        : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_GOAL_POINT_WIN.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ?
                        props.item.awayStat.gpW
                        :
                        props.item.awayStat.gpWT
                        : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_GOAL_POINT_DRAW.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ?
                        props.item.awayStat.gpD
                        :
                        props.item.awayStat.gpDT
                        : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_GOAL_POINT_LOSE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ?
                        props.item.awayStat.gpL
                        :
                        props.item.awayStat.gpLT
                        : "-"}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.A_POINT_PER_GAME.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.pointPerGame : props.item.awayStat.pointPerGameTotal : "-"}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.A_GOALS_SCORED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.goalsScored : props.item.awayStat.goalsScoredTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_GOALS_CONCEDED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.goalsConceded : props.item.awayStat.goalsConcededTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_AVG_GOALS_SCORED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.avgGoalsScored : props.item.awayStat.avgGoalsScoredTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_AVG_GOALS_CONCEDED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.avgGoalsConceded : props.item.awayStat.avgGoalsConcededTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_AVG_GOALS_SCORED_CONCEDED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{formatNumber(props.item.awayStat ? props.away === AWAY ? props.item.awayStat.avgGoalsScoredConc : props.item.awayStat.avgGoalsScoredConcTotal : "-")}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_ONE_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overOnePointFiveGoals : props.item.awayStat.overOnePointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_TWO_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overTwoPointFiveGoals : props.item.awayStat.overTwoPointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_THREE_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overThreePointFiveGoals : props.item.awayStat.overThreePointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_FOUR_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overFourPointFiveGoals : props.item.awayStat.overFourPointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_FIVE_POINT_FIVE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overFivePointFiveGoals : props.item.awayStat.overFivePointFiveGoalsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_ZERO_POINT_FIVE_HT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overZeroPointFiveGoalsHT : props.item.awayStat.overZeroPointFiveGoalsHTTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_ONE_POINT_FIVE_HT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overOnePointFiveGoalsHT : props.item.awayStat.overOnePointFiveGoalsHTTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_OVER_TWO_POINT_FIVE_HT.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.overTwoPointFiveGoalsHT : props.item.awayStat.overTwoPointFiveGoalsHTTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_CLEAN_SHEETS.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.cleanSheets : props.item.awayStat.cleanSheetsTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_WON_TO_NIL.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.wonToNil : props.item.awayStat.wonToNilTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_SCORED_IN_BOTH_HALVES.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.scoredInBothHalves : props.item.awayStat.scoredInBothHalvesTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_BOTH_TEAMS_SCORED.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.bothTeamsScored : props.item.awayStat.bothTeamsScoredTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_FAILED_TO_SCORE.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.failedToScore : props.item.awayStat.failedToScoreTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_LOST_TO_NIL.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.lostToNil : props.item.awayStat.lostToNilTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_CONCEDED_IN_BOTH_HALVES.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.concededInBothHalves : props.item.awayStat.concededInBothHalvesTotal : "-"}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.A_POINT_PER_GAME.id:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.pointPerGame : props.item.awayStat.pointPerGameTotal : "-"}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.A_CORNER_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.cpm : props.item.awayStat.cpmT : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_AGAINST_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.capm : props.item.awayStat.capmT : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_TTL_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.tcpm : props.item.awayStat.tcpmT : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_OVER_9_5_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.o9_5 : props.item.awayStat.o9_5T : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_OVER_10_5_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.o10_5 : props.item.awayStat.o10_5T : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_OVER_11_5_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.o11_5 : props.item.awayStat.o11_5T : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_OVER_12_5_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.o12_5 : props.item.awayStat.o12_5T : "-"}</td>
                 break;
                 case MATCH_TABLE_COLUMNS_ALL.A_CORNER_OVER_13_5_PER_MATCH.id:
                     cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{props.item.awayStat ? props.away === AWAY ? props.item.awayStat.o13_5 : props.item.awayStat.o13_5T : "-"}</td>
                 break;

                // calculated columns
                case MATCH_TABLE_COLUMNS_ALL.COMB_GOALS_SCORED_CONCEDED.id:
                    // let cellValueCombGoalsScoredConc = "-"
                    // if(props.item.homeStat !== null && props.item.awayStat !== null) {
                    //     cellValueCombGoalsScoredConc = getAverageValue(props.home === HOME ? props.item.homeStat.avgGoalsScoredConc : props.item.homeStat.avgGoalsScoredConcTotal, 
                    //         props.away === AWAY ? props.item.awayStat.avgGoalsScoredConc : props.item.awayStat.avgGoalsScoredConcTotal)
                    // }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.combGoalsScoredConc}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.COMB_OVER_TWO_POINT_FIVE.id:
                    // let cellValueCombOverTwoPointFive = "-"
                    // if(props.item.homeStat !== null && props.item.awayStat !== null) {
                    //     cellValueCombOverTwoPointFive = getAverageValue(props.home === HOME ? props.item.homeStat.overTwoPointFiveGoals : props.item.homeStat.overTwoPointFiveGoalsTotal, 
                    //         props.away === AWAY ? props.item.awayStat.overTwoPointFiveGoals : props.item.awayStat.overTwoPointFiveGoalsTotal)
                    // }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.combOverTwoPointFive}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.COMB_BTTS.id:
                    // let cellValueCombBtts = "-"
                    // if(props.item.homeStat !== null && props.item.awayStat !== null) {
                    //     cellValueCombBtts = getAverageValue(props.home === HOME ? props.item.homeStat.bothTeamsScored : props.item.homeStat.bothTeamsScoredTotal, 
                    //         props.away === AWAY ? props.item.awayStat.bothTeamsScored : props.item.awayStat.bothTeamsScoredTotal)
                    // }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{props.item.combBtts}</td>
                    break;

                // result columns
                case MATCH_TABLE_COLUMNS_ALL.RESULT_FT.id:
                    const resultFt = props.item.resultFT ? props.item.resultFT.home + "-" + props.item.resultFT.away : "-"
                    const finalDot = props.item.resultFT ? dot : null
                    cell = <td style={{display: 'none'}} key={cellKey} className={classes.MatchTdTh}>{resultFt}{finalDot}</td>
                    break;
                //case MATCH_TABLE_COLUMNS_ALL.RESULT_HT.id:
                //    cell = <td key={cellKey} className={classes.MatchTdTh}>NA</td>
                //break;

                //odds 
                case MATCH_TABLE_COLUMNS_ALL.ODDS_HOME_TEAM.id:
                    const homeTeamName = props?.item?.matchOdd?.fixture?.teams?.home?.name
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{homeTeamName != undefined ? homeTeamName : '-'}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_AWAY_TEAM.id:
                    const awayTeamName = props?.item?.matchOdd?.fixture?.teams?.away?.name
                    cell = <td key={cellKey} style={{display: 'none'}} className={classes.MatchTdTh}>{awayTeamName != undefined ? awayTeamName : '-'}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_STATUS.id:
                    var matchStatus = '-';
                    if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.fixture && props.item.matchOdd.fixture.fixture.status) {
                        matchStatus = props.item.matchOdd.fixture.fixture.status.longName;
                    }
                    if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.fixture
                        && props.item.matchOdd.fixture.fixture.time
                        && typeof props.item.matchOdd.fixture.fixture.time != "undefined") {
                        matchStatus = matchStatus + "(" + props.item.matchOdd.fixture.fixture.time + ")";
                    }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{matchStatus}</td>
                    break;


                case MATCH_TABLE_COLUMNS_ALL.ODDS_FINAL_SCORE.id:
                    const fullScore = props.item.matchOdd ?
                        props.item.matchOdd.fixture ? formatScore(props.item.matchOdd.fixture.score.fulltime.home, props.item.matchOdd.fixture.score.fulltime.away) : '-'
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{fullScore}{dot}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HALF_TIME_SCORE.id:
                    const halfTimeScore = props.item.matchOdd ?
                        props.item.matchOdd.fixture ? formatScore(props.item.matchOdd.fixture.score.halftime.home, props.item.matchOdd.fixture.score.halftime.away) : '-'
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{halfTimeScore}{dot}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_SECOND_HALF_TIME_SCORE.id:
                    var secondHalfTimeScore = '-';
                    if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.score.fulltime.home != null &&
                        props.item.matchOdd.fixture.score.halftime.home != null) {
                        secondHalfTimeScore =
                            formatScore(
                                (props.item.matchOdd.fixture.score.fulltime.home - props.item.matchOdd.fixture.score.halftime.home)
                                ,
                                (props.item.matchOdd.fixture.score.fulltime.away - props.item.matchOdd.fixture.score.halftime.away)
                            );
                    }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{secondHalfTimeScore}{dot}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_TOTAL_GOALS.id:
                    var totalGoals = '-';
                    if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.score.fulltime.home != null) {
                        totalGoals = props.item.matchOdd.fixture.score.fulltime.home + props.item.matchOdd.fixture.score.fulltime.away;
                    } else if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.score.halftime.home != null) {
                        totalGoals = props.item.matchOdd.fixture.score.halftime.home + props.item.matchOdd.fixture.score.halftime.away;
                    }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{totalGoals}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_TOTAL_HALF_TIME_GOAL.id:
                    var totalGoalsHT = '-';
                    if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.score.halftime.home != null &&
                        props.item.matchOdd.fixture.score.halftime.away != null) {
                        totalGoalsHT = props.item.matchOdd.fixture.score.halftime.home + props.item.matchOdd.fixture.score.halftime.away;
                    }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{totalGoalsHT}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_TOTAL_SCOND_HALF_TIME_GOAL.id:
                    var totalGoals2H = '-';
                    if (props.item.matchOdd && props.item.matchOdd.fixture && props.item.matchOdd.fixture.score && props.item.matchOdd.fixture.score.fulltime.home != null &&
                        props.item.matchOdd.fixture.score.halftime.home != null) {
                        totalGoals2H =
                            (props.item.matchOdd.fixture.score.fulltime.home + props.item.matchOdd.fixture.score.fulltime.away)
                            -
                            (props.item.matchOdd.fixture.score.halftime.home + props.item.matchOdd.fixture.score.halftime.away);
                    }
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{totalGoals2H}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_MATCH_WINNER_HOME.id:
                    const oddMatchWinnerHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "Match Winner")].values[?(@.value== "Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddMatchWinnerHome}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_MATCH_WINNER_DRAW.id:
                    const oddMatchWinnerDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "Match Winner")].values[?(@.value== "Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddMatchWinnerDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_MATCH_WINNER_AWAY.id:
                    const oddMatchWinnerAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "Match Winner")].values[?(@.value== "Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddMatchWinnerAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_UNDER_0_5.id:
                    const oddsUnder05 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Under 0.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsUnder05}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_OVER_0_5.id:
                    const oddsOver05 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Over 0.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsOver05}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_UNDER_1_5.id:
                    const oddsUnder15 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Under 1.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsUnder15}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_OVER_1_5.id:
                    const oddsOver15 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Over 1.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsOver15}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_UNDER_2_5.id:
                    const oddsUnder25 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Under 2.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsUnder25}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_OVER_2_5.id:
                    const oddsOver25 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Over 2.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsOver25}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_UNDER_3_5.id:
                    const oddsUnder35 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Under 3.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsUnder35}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_OVER_3_5.id:
                    const oddsOver35 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Over 3.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsOver35}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_UNDER_4_5.id:
                    const oddsUnder45 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Under 4.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsUnder45}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_OVER_4_5.id:
                    const oddsOver45 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Goals Over/Under")].values[?(@.value== "Over 4.5" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsOver45}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_FIRST_HALF_WINNER_HOME.id:
                    const firstHalfWinnerHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "First Half Winner")].values[?(@.value== "Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{firstHalfWinnerHome}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_FIRST_HALF_WINNER_DRAW.id:
                    const firstHalfWinnerDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "First Half Winner")].values[?(@.value== "Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{firstHalfWinnerDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_FIRST_HALF_WINNER_AWAY.id:
                    const firstHalfWinnerAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "First Half Winner")].values[?(@.value== "Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{firstHalfWinnerAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_SECOND_HALF_WINNER_HOME.id:
                    const secondHalfWinnerHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "Second Half Winner")].values[?(@.value== "Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{secondHalfWinnerHome}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_SECOND_HALF_WINNER_DRAW.id:
                    const secondHalfWinnerDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "Second Half Winner")].values[?(@.value== "Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{secondHalfWinnerDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_SECOND_HALF_WINNER_AWAY.id:
                    const secondHalfWinnerAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "Second Half Winner")].values[?(@.value== "Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{secondHalfWinnerAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_DOUBLE_CHANCE_HOME_DRAW.id:
                    const doubeChanceHomeDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "Double Chance")].values[?(@.value== "Home/Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{doubeChanceHomeDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_DOUBLE_CHANCE_HOME_AWAY.id:
                    const doubleChanceHomeAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "Double Chance")].values[?(@.value== "Home/Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{doubleChanceHomeAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_DOUBLE_CHANCE_DRAW_AWAY.id:
                    const oddsDoubleChanceDrawAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "Double Chance")].values[?(@.value== "Draw/Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddsDoubleChanceDrawAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_ODD_EVEN_EVEN.id:
                    const oddEvenEven = bets365Details ?
                        getDetails('$..bets[?(@.name== "Odd/Even")].values[?(@.value== "Even" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddEvenEven}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_ODD_EVEN_ODD.id:
                    const oddEvenOdd = bets365Details ?
                        getDetails('$..bets[?(@.name== "Odd/Even")].values[?(@.value== "Odd" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddEvenOdd}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_ODD_EVEN_FIRST_HALF_EVEN.id:
                    const oddEvenEvenFirstHalf = bets365Details ?
                        getDetails('$..bets[?(@.name== "Odd/Even - First Half")].values[?(@.value== "Even" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddEvenEvenFirstHalf}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_ODD_EVEN_FIRST_HALF_ODD.id:
                    const oddEvenOddFirstHalf = bets365Details ?
                        getDetails('$..bets[?(@.name== "Odd/Even - First Half")].values[?(@.value== "Odd" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddEvenOddFirstHalf}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_ODD_EVEN_SECOND_HALF_EVEN.id:
                    const oddEvenEvenSecondHalf = bets365Details ?
                        getDetails('$..bets[?(@.name== "Odd/Even - Second Half")].values[?(@.value== "Even" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddEvenEvenSecondHalf}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_ODD_EVEN_SECOND_HALF_ODD.id:
                    const oddEvenOddSecondHalf = bets365Details ?
                        getDetails('$..bets[?(@.name== "Odd/Even - Second Half")].values[?(@.value== "Odd" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{oddEvenOddSecondHalf}</td>
                    break;

                //HTFT START
                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_HOME_HOME.id:
                    const htftHomeHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Home/Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftHomeHome}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_DRAW_DRAW.id:
                    const htftDrawDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Draw/Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftDrawDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_DRAW_AWAY.id:
                    const htftDrawAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Draw/Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftDrawAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_HOME_AWAY.id:
                    const htftHomeAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Home/Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftHomeAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_HOME_DRAW.id:
                    const htftHomeDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Home/Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftHomeDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_AWAY_AWAY.id:
                    const gtftAwayAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Away/Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{gtftAwayAway}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_AWAY_DRAW.id:
                    const htftAwayDraw = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Away/Draw" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftAwayDraw}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_AWAY_HOME.id:
                    const htftAwayHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Away/Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftAwayHome}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_HTFT_DRAW_HOME.id:
                    const htftDrawHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "HT/FT Double")].values[?(@.value== "Draw/Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{htftDrawHome}</td>
                    break;

                //HTFT END

                //ODDS CORRECT SCORE START

                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_00.id:
                    const coerrectScore00 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "0:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore00}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_01.id:
                    const coerrectScore01 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "0:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore01}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_02.id:
                    const coerrectScore02 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "0:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore02}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_03.id:
                    const coerrectScore03 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "0:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore03}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_10.id:
                    const coerrectScore10 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "1:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore10}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_11.id:
                    const coerrectScore11 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "1:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore11}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_12.id:
                    const coerrectScore12 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "1:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore12}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_13.id:
                    const coerrectScore13 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "1:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore13}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_20.id:
                    const coerrectScore20 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "2:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore20}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_21.id:
                    const coerrectScore21 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "2:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore21}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_22.id:
                    const coerrectScore22 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "2:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore22}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_23.id:
                    const coerrectScore23 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "2:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore23}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_30.id:
                    const coerrectScore30 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "3:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore30}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_31.id:
                    const coerrectScore31 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "3:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore31}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_32.id:
                    const coerrectScore32 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "3:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore32}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_33.id:
                    const coerrectScore33 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "3:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore33}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_14.id:
                    const coerrectScore14 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "1:4" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore14}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_24.id:
                    const coerrectScore24 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "2:4" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore24}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_34.id:
                    const coerrectScore34 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "3:4" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore34}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_40.id:
                    const coerrectScore40 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "4:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore40}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_44.id:
                    const coerrectScore44 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "4:4" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore44}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_50.id:
                    const coerrectScore50 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "5:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore50}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_51.id:
                    const coerrectScore51 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Exact Score")].values[?(@.value== "5:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScore51}</td>
                    break;

                //ODDS CORRECT SCORE END

                //CORRECT SCORE 1st HALF START
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_00.id:
                    const coerrectScoreFirstHalf00 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "0:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf00}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_01.id:
                    const coerrectScoreFirstHalf01 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "0:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf01}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_02.id:
                    const coerrectScoreFirstHalf02 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "0:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf02}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_03.id:
                    const coerrectScoreFirstHalf03 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "0:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf03}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_10.id:
                    const coerrectScoreFirstHalf10 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "1:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf10}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_11.id:
                    const coerrectScoreFirstHalf11 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "1:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf11}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_12.id:
                    const coerrectScoreFirstHalf12 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "1:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf12}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_13.id:
                    const coerrectScoreFirstHalf13 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "1:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf13}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_20.id:
                    const coerrectScoreFirstHalf20 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "2:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf20}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_21.id:
                    const coerrectScoreFirstHalf21 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "2:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf21}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_22.id:
                    const coerrectScoreFirstHalf22 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "2:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf22}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_23.id:
                    const coerrectScoreFirstHalf23 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "2:3" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf23}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_30.id:
                    const coerrectScoreFirstHalf30 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "3:0" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf30}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_31.id:
                    const coerrectScoreFirstHalf31 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "3:1" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf31}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_32.id:
                    const coerrectScoreFirstHalf32 = bets365Details ?
                        getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "3:2" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf32}</td>
                    break;
                /*case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_33.id:
                    const coerrectScoreFirstHalf33 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "3:3" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf33}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_14.id:
                    const coerrectScoreFirstHalf14 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "1:4" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf14}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_24.id:
                    const coerrectScoreFirstHalf24 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "2:4" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf24}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_34.id:
                    const coerrectScoreFirstHalf34 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "3:4" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf34}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_40.id:
                    const coerrectScoreFirstHalf40 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "4:0" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf40}</td>
                break;
                
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_44.id:
                    const coerrectScoreFirstHalf44 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "4:4" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf44}</td>
                break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_50.id:
                    const coerrectScoreFirstHalf50 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "5:0" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf50}</td>
                break;
    
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_FIRST_HALF_51.id:
                    const coerrectScoreFirstHalf51 = bets365Details ?
                    getDetails('$..bets[?(@.name== "Correct Score - First Half")].values[?(@.value== "5:1" )].odd')
                     :
                     '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreFirstHalf51}</td>
                break;
                */

                //CORRECT SCORE 1st HALF END

                //CORRECT SCORE 2nd HALF START
                /*
                case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_00.id:
                   const coerrectScoreSecondHalf00 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "0:0" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf00}</td>
               break;
   
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_01.id:
                   const coerrectScoreSecondHalf01 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "0:1" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf01}</td>
               break;
   
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_02.id:
                   const coerrectScoreSecondHalf02 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "0:2" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf02}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_03.id:
                   const coerrectScoreSecondHalf03 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "0:3" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf03}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_10.id:
                   const coerrectScoreSecondHalf10 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "1:0" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf10}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_11.id:
                   const coerrectScoreSecondHalf11 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "1:1" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf11}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_12.id:
                   const coerrectScoreSecondHalf12 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "1:2" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf12}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_13.id:
                   const coerrectScoreSecondHalf13 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "1:3" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf13}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_20.id:
                   const coerrectScoreSecondHalf20 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "2:0" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf20}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_21.id:
                   const coerrectScoreSecondHalf21 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "2:1" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf21}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_22.id:
                   const coerrectScoreSecondHalf22 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "2:2" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf22}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_23.id:
                   const coerrectScoreSecondHalf23 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "2:3" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf23}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_30.id:
                   const coerrectScoreSecondHalf30 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "3:0" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf30}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_31.id:
                   const coerrectScoreSecondHalf31 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "3:1" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf31}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_32.id:
                   const coerrectScoreSecondHalf32 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "3:2" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf32}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_33.id:
                   const coerrectScoreSecondHalf33 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "3:3" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf33}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_14.id:
                   const coerrectScoreSecondHalf14 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "1:4" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf14}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_24.id:
                   const coerrectScoreSecondHalf24 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "2:4" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf24}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_34.id:
                   const coerrectScoreSecondHalf34 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "3:4" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf34}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_04.id:
                   const coerrectScoreSecondHalf04 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "0:4" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf04}</td>
               break;
               /*
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_44.id:
                   const coerrectScoreSecondHalf44 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "4:4" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf44}</td>
               break;
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_50.id:
                   const coerrectScoreSecondHalf50 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "5:0" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf50}</td>
               break;
   
               case MATCH_TABLE_COLUMNS_ALL.ODDS_CORRECT_SCORE_SECOND_HALF_51.id:
                   const coerrectScoreSecondHalf51 = bets365Details ?
                   getDetails('$..bets[?(@.name== "Correct Score - Second Half")].values[?(@.value== "5:1" )].odd')
                    :
                    '-';
                   cell = <td key={cellKey} className={classes.MatchTdTh}>{coerrectScoreSecondHalf51}</td>
               break;
               */

                //CORRECT SCORE 2nd HALF END
                case MATCH_TABLE_COLUMNS_ALL.ODDS_BTTS_YES.id:
                    const bttsYes = bets365Details ?
                        getDetails('$..bets[?(@.name== "Both Teams Score")].values[?(@.value== "Yes" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{bttsYes}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_BTTS_NO.id:
                    const bttsNo = bets365Details ?
                        getDetails('$..bets[?(@.name== "Both Teams Score")].values[?(@.value== "No" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{bttsNo}</td>
                    break;
                //Draw No Bets Start
                case MATCH_TABLE_COLUMNS_ALL.ODDS_DRAW_NB_HOME.id:
                    const brawNoBetHome = bets365Details ?
                        getDetails('$..bets[?(@.name== "Home/Away")].values[?(@.value== "Home" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{brawNoBetHome}</td>
                    break;

                case MATCH_TABLE_COLUMNS_ALL.ODDS_DRAW_NB_AWAY.id:
                    const brawNoBetAway = bets365Details ?
                        getDetails('$..bets[?(@.name== "Home/Away")].values[?(@.value== "Away" )].odd')
                        :
                        '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{brawNoBetAway}</td>
                    break;
                /*case MATCH_TABLE_COLUMNS_ALL.ODDS_DRAW_NB_FIRST_HALF_HOME.id:
                    const brawNoBetFirstHome = bets365Details ?
                    getDetails('$..bets[?(@.name== "Both Teams Score")].values[?(@.value== "Yes" )].odd')
                    :
                    '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{brawNoBetFirstHome}</td>
                    break;
                    
                case MATCH_TABLE_COLUMNS_ALL.ODDS_DRAW_NB_FIRST_HALF_AWAY.id:
                    const brawNoBetFirstAway = bets365Details ?
                    getDetails('$..bets[?(@.name== "Both Teams Score")].values[?(@.value== "No" )].odd')
                    :
                    '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{brawNoBetFirstAway}</td>
                    break;
                case MATCH_TABLE_COLUMNS_ALL.ODDS_DRAW_NB_SECOND_HALF_HOME.id:
                    const brawNoBetSecondHome = bets365Details ?
                    getDetails('$..bets[?(@.name== "Both Teams Score")].values[?(@.value== "Yes" )].odd')
                    :
                    '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{brawNoBetSecondHome}</td>
                    break;
                    
                case MATCH_TABLE_COLUMNS_ALL.ODDS_DRAW_NB_SECOND_HALF_AWAY.id:
                    const brawNoBetSecondAway = bets365Details ?
                    getDetails('$..bet[?(@.name== "Both Teams Score")].values[?(@.value== "No" )].odd')
                    :
                    '-';
                    cell = <td key={cellKey} className={classes.MatchTdTh}>{brawNoBetSecondAway}</td>
                    break;
                    */
                //Draw No Bets End

                default:
                    cell = <td key={cellKey} className={classes.MatchTdTh}>UNKNOWN</td>
            }
            return cell;
        })

        return (
            <tr className={classes.Match} style={{ backgroundColor: this.state.bgColor }} onClick={this.rowClicked}>
                {cells}
            </tr>
        )
    }
}

export default Match;
